import styled from 'styled-components'
import {AddIcon} from '@modifi/ui'

export const StyledAddIcon = styled(AddIcon)`
  margin-right: 8px !important;
  margin-left: -4px;
  margin-bottom: 1px;
`
